<template>
  <div>
    <template v-if="statusType">
      <div class="lp-toast-status" v-show="vToast"
        >
        <div class="msg">
          <i class="unselect material-icons">check</i>
          <div>{{ msg }}</div>
        </div>
        <i class="unselect material-icons" @click="cancel">close</i>
      </div>
    </template>
    <template v-else>
      <transition name="fade">
        <div class="lp-toast-bg" v-show="vToast" @click="cancel">
          <div class="lp-toast unselect">{{ msg }}</div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
  export default {
    created() {
      this.$root.$on('toast', res => {
        this.statusType = false;
        this.cancel();
        this.setToast(res, this.delay);
      });

      this.$root.$on('toastStatus', res => {
        this.statusType = true;
        this.cancel();
        this.setToast(res, 8000);
        // setTimeout(() => {
        //   setTimeout(() => {
        //      document.getElementsByClassName('lp-toast-status')[0].classList.remove('show');
        //      document.getElementsByClassName('lp-toast-status')[0].classList.add('hide');
        //   }, 4750)
        // }, 1000)
      });

      this.$root.$on('toastTime', res => {
        this.statusType = false;
        this.cancel();
        this.setToast(res.msg, res.time ? res.time : this.delay);
      });
    },
    data() {
      return {
        delay: 3000,
        vToast: false,
        msg: '',
        func: undefined,
        statusType: false
      }
    },
    methods: {
      setToast(res, delay) {
        this.msg = res;
        this.vToast = true;
        this.func = setTimeout(() => {
          this.vToast = false;
        }, delay);
      },
      cancel() {
        if(this.func) {
          clearTimeout(this.func);
        }
        this.vToast = false;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-toast-bg
    position fixed
    z-index 9002
    top 0
    left 0
    right 0
    bottom 0
    width 100%
    height 100%
    display flex

  .lp-toast
    width 60%
    max-width 380px
    margin auto
    padding 12px
    font-size 0.9rem
    color white
    background-color rgba(0,0,0,0.65)
    text-align center
    border-radius 4px
    white-space pre-line

  .lp-toast-status
    position fixed
    transform translateX(-50%)
    left 50%
    bottom 24px
    background-color #363636
    padding 24px 16px
    padding-left 20px
    color white
    font-size 16px
    font-weight 700
    display flex
    z-index 1026
    width 556px
    height 76px
    justify-content space-between
    gap 0 4px
    box-shadow 0px 4px 14px rgba(0, 0, 0, 0.55)
    border-radius 8px

    .msg
      flex 1
      display flex
      align-items center
      justify-content center
      gap 0 4px
      text-align center
      color white
    i
      font-size 24px
      color white

  .show
    animation moveInTop .25s ease-out
  .hide
    animation hide .25s ease-out

  .fade-enter-active
  .fade-leave-active
    transition opacity .3s
  .fade-enter
  .fade-leave-to
    opacity 0


  @keyframes moveInTop
    0%
      transform translate3d(0, -100%, 0)
    to
      transform translateZ(0)

  @keyframes hide
    0%
      transform translateZ(0)
    to
      transform translate3d(0, -100%, 0)
</style>
